// Alfresco
import {
  CardViewItem,
  DynamicComponentModel,
  CardViewBaseItemModel,
} from '@alfresco/adf-core';

// Project
import { CardViewTableItemProperties } from '../interfaces/card-view-table-item-properties.interface';

export class CardViewTableItemModel
  extends CardViewBaseItemModel
  implements CardViewItem, DynamicComponentModel
{
  type = 'table';

  constructor(cardViewTableItemProperties: CardViewTableItemProperties) {
    super(cardViewTableItemProperties);
  }

  get displayValue() {
    return this.value;
  }
}
